/*
 * @Author: Teemo Ding
 * @Date: 2022-04-13 16:33:37
 * @LastEditTime: 2022-05-12 10:28:16
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/permission/index.ts
 */

import { get, post } from 'src/tools/server';
import { getUserInfo } from '@/src/tools/getUserInfo';
import { get as lodashGet } from 'lodash';

export const getPermissionList = (storeUuid) => {
  return get<any>(`/config/user/listPage/${storeUuid}`, {});
};

export const getInviteUser = (storeUuid) => {
  return get<any>(`/config/user/invite/${storeUuid}`, {});
};
export const getEditUser = (storeUuid, userUuid) => {
  return get<any>(`/config/user/edit/${storeUuid}/${userUuid}`, {});
};

export const saveUser = (storeUuid, userUuid, data) => {
  return post<any>(`/config/user/edit/${storeUuid}/${userUuid}`, data, {});
};
export const sendInviteUser = (storeUuid, data) => {
  return post<any>(`/config/user/invite/${storeUuid}`, data, {});
};

export const requireTwoFactor = (storeUuid, requireTFA) => {
  return get<any>(
    `/config/user/store/requireTwoFactor/${storeUuid}/${requireTFA}`,
    {},
  );
};

export const getUserList = (storeUuid) => {
  return get<any>(`/config/user/list/${storeUuid}`, {});
};

export const removeUser = (data) => {
  return post<any>(`/config/user/remove`, data, {});
};

export const transferOwnership = (data) => {
  return post<any>(`/config/user/transferOwnership`, data, {});
};

export const updatePermission = () => {
  const info = getUserInfo();
  const userUuid = lodashGet(info, 'userUuid');
  const storeUuid = lodashGet(info, 'storeUuid');
  return get<any>(`/config/user/permissions/${userUuid}/${storeUuid}`, {});
};
